import { useCallback, useEffect, useState } from "react";
import {
  Form,
  Popconfirm,
  Row,
} from "../../common/utils/antd-imports/AntdImports";
import { ReactComponent as DragImageIcon } from "../../../assests/drag-image-icon.svg";
import { ReactComponent as AddIcon } from "../../../assests/add-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assests/delete-icon.svg";
import FloatingSelect from "../floating-select/floatingSelect";
import {
  deleteImageFromBillBoard,
  getProductDetails,
} from "../../../store/thunks/seller-thunks/SellerThunk";
import { useDispatch } from "react-redux";
import { API_BASE_URL_IMAGE } from "../../../services/common";

const BillboardImageUploader = ({
  id,
  billboardFiles,
  isClone = false,
  setBinaryImages,
  setFiles,
  fileInputRef,
  product,
  floatingSelectStyles,
}) => {
  const dispatch = useDispatch();
  const [imageError, setImageError] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const handleFileChange = (event) => {
    if (event.target.files && event.target.files?.length > 0) {
      (Array.from(event.target.files).length > 3 ||
      billboardFiles?.length + Array.from(event.target.files)?.length > 3
        ? Array.from(event.target.files).slice(
            0,
            3 - (billboardFiles?.length || 0)
          )
        : Array.from(event.target.files)
      ).forEach((file) => {
        const maxSizeInBytes = 5 * 1024 * 1024;
        if (file.size > maxSizeInBytes) {
          setImageError("File size should not exceed 5MB.");
          event.target.value = "";
          return;
        }

        const img = new window.Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          if (img.width === 1280 || img.height === 960) {
            const reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = () => {
              const fileData = {
                name: file.name,
                binary: new Blob([reader.result], { type: file.type }),
              };
              setBinaryImages((prevImages) => [...prevImages, fileData]);
            };
            setFiles((prevFiles) => [...prevFiles, file]);
          } else {
            setImageError(true);
            event.target.value = "";
          }
        };
      });
    }
  };

  const handleDeleteImage = useCallback(
    (e, img, billBoardindex) => {
      e.stopPropagation();
      setFiles((prevImages) =>
        prevImages?.filter((_img, index) => index !== billBoardindex)
      );
      setBinaryImages((prevBinaryImages) =>
        prevBinaryImages?.filter((_binary, index) => index !== billBoardindex)
      );
      if (product && !(img instanceof File)) {
        if (!isClone) {
          dispatch(
            deleteImageFromBillBoard({
              product_id: product?.id,
              image_index: billBoardindex,
            })
          ).then(() => {
            dispatch(getProductDetails(id));
          });
        }
      }
      if (billboardFiles?.length <= 1) {
        setSelectedFile(null);
      }
    },
    [billboardFiles?.length, id, product]
  );

  useEffect(() => {
    if (billboardFiles?.length > 0) {
      setSelectedFile(billboardFiles?.[0]);
    }
  }, [billboardFiles]);

  return (
    <>
      <input
        type="file"
        accept=".jpg, .jpeg"
        multiple
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <p className="add-billboard-css add-billboard-design">MEDIA</p>
      {billboardFiles?.length > 0 ? (
        <img
          className="billboard-image-main-div"
          src={(() => {
            if (selectedFile instanceof File) {
              return URL.createObjectURL(selectedFile);
            } else if (billboardFiles?.[0] instanceof File) {
              return URL.createObjectURL(billboardFiles[0]);
            } else if (selectedFile || billboardFiles?.[0]) {
              return `${API_BASE_URL_IMAGE}${
                selectedFile || billboardFiles[0]
              }`;
            } else if (product?.image && product.image.length > 0) {
              return `${API_BASE_URL_IMAGE}${product.image}`;
            } else {
              return "";
            }
          })()}
          alt="Product Preview"
        ></img>
      ) : (
        <div className="add-billboard-images">
          <>
            <DragImageIcon style={{ marginBottom: "1rem" }} />
            <p style={{ textAlign: "center" }}>
              Showcase Your Product! Upload a Clear and High-Quality Image.
            </p>
            {imageError && (
              <p style={{ color: "#d2042d" }}>
                Uploaded image has valid Width 1280px and Height 960px.
                <br></br>
                To resize your image please go to <br></br>{" "}
                <a
                  href="https://www.resizepixel.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.resizepixel.com
                </a>
              </p>
            )}
            <div
              style={{ cursor: "pointer" }}
              onClick={() => fileInputRef.current?.click()}
            >
              <span>Drag & Drop or </span>
              <span className="add-billboard-css"> Click</span>
              <span> to Upload Your Image</span>
            </div>
            <p>or</p>
            <Form.Item name="default_image_type" style={{ width: "50%" }}>
              <FloatingSelect
                className="billboard-select-feild"
                label={<>Pick a Predefined Image </>}
                options={[
                  { id: "Default", name: "Use Default Image" },
                  { id: "AdmitOne", name: "Admission" },
                  { id: "ParkingPass", name: "Ticket" },
                  { id: "Promotion", name: "Promotion" },
                  { id: "Exclusive", name: "Exclusive" },
                ]}
                isChannels={true}
                customStyles={floatingSelectStyles}
              />
            </Form.Item>
            <div className="billboard-image-css">
              Supported formats: JPG, JPEG (Max size: 5MB).
            </div>
          </>
        </div>
      )}
      {billboardFiles?.length > 0 && (
        <Row className="billboard-image-thumbnail-row">
          {billboardFiles?.map((img, billBoardindex) => {
            let imageUrl = "none";
            if (img instanceof File) {
              imageUrl = URL.createObjectURL(img);
            } else if (typeof img === "string" && img.trim() !== "") {
              imageUrl = new URL(img, API_BASE_URL_IMAGE)?.toString();
            }
            return (
              <div
                key={billBoardindex}
                className="billboard-image"
                style={{
                  backgroundImage:
                    imageUrl !== "none" ? `url("${imageUrl}")` : "none",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                onClick={() => setSelectedFile(img)}
              >
                <Popconfirm
                  title="Confirm!"
                  description="Are you sure to delete this image permanently?"
                  onConfirm={(e) => handleDeleteImage(e, img, billBoardindex)}
                  okText="Confirm"
                  cancelText="Cancel"
                  okButtonProps={{
                    style: { backgroundColor: "#d2042d", color: "#fff" },
                  }}
                  cancelButtonProps={{
                    style: {
                      backgroundColor: "#DEDEDE",
                      color: "#000",
                      borderColor: "#DEDEDE",
                    },
                  }}
                >
                  <div className="billboard-delete-image">
                    <DeleteIcon />
                  </div>
                </Popconfirm>
              </div>
            );
          })}

          {billboardFiles?.length < 3 && (
            <div
              className="billboard-add-image"
              onClick={() => fileInputRef.current?.click()}
            >
              <AddIcon />
            </div>
          )}
        </Row>
      )}
    </>
  );
};

export default BillboardImageUploader;
